const PREFIX = "cart-de-tip";

export const DE_TIP_WIDGET_DATA_TEST_IDS = {
    LOTTIE_PRE_ADD: `${PREFIX}-lottie-pre-tip-add`,
    IMG_POST_ADD: `${PREFIX}-img-post-tip-add`,
};
